﻿import './sections.css'

export default function SolutionSection() {
  return (
    <section id="products" className="solution-section section">
      <div className="container">
        <h2 className="section-title">The Workforce Intelligence Loop</h2>
        <p className="section-subtitle">One conversational AI platform — four modules that connect and compound across the employee lifecycle.</p>

        {/* Flow pills */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: '0.5rem', margin: '2rem auto 1.5rem', maxWidth: '680px' }}>
          <span style={{ background: '#1c2b3a', color: 'white', padding: '0.6rem 1.4rem', borderRadius: '8px', fontWeight: 700, fontSize: '0.95rem' }}>Hire</span>
          <span style={{ color: '#c9a84c', fontSize: '1.4rem', fontWeight: 800 }}>→</span>
          <span style={{ background: '#1c2b3a', color: 'white', padding: '0.6rem 1.4rem', borderRadius: '8px', fontWeight: 700, fontSize: '0.95rem' }}>Assess</span>
          <span style={{ color: '#c9a84c', fontSize: '1.4rem', fontWeight: 800 }}>→</span>
          <span style={{ background: '#1c2b3a', color: 'white', padding: '0.6rem 1.4rem', borderRadius: '8px', fontWeight: 700, fontSize: '0.95rem' }}>Develop</span>
          <span style={{ color: '#c9a84c', fontSize: '1.4rem', fontWeight: 800 }}>→</span>
          <span style={{ background: '#c9a84c', color: '#0e1820', padding: '0.6rem 1.4rem', borderRadius: '8px', fontWeight: 700, fontSize: '0.95rem' }}>Assist</span>
        </div>

        <p style={{ textAlign: 'center', color: '#64748b', fontSize: '0.92rem', margin: '0 auto 2.5rem', maxWidth: '580px', fontStyle: 'italic' }}>
          Each stage generates intelligence that feeds the next — so your organisation continuously improves hiring, develops capability, and drives workforce productivity over time.
        </p>

        <div className="products-grid">

          {/* SmartHire */}
          <div className="product-card">
            <div className="product-icon">✓</div>
            <h3>SmartHire</h3>
            <p>Conversational AI interviews that identify the right talent — evaluating real capability, not just resumes.</p>
            <p>Built-in interview fraud detection and AI interview cheating detection flag AI-assisted responses in real time.</p>
            <ul className="results-list">
              <li>→ Adaptive conversational interviews</li>
              <li>→ Scenario-based coding interviews</li>
              <li>→ Competency-based evaluation</li>
              <li>→ Patented integrity detection — flags AI-assisted responses in real time</li>
              <li>→ Industry-agnostic hiring</li>
            </ul>
            <p style={{ marginTop: '1rem', fontStyle: 'italic', color: 'var(--text-light)', fontSize: '0.95rem' }}>SmartHire evaluates how candidates think, not just what answers they give. Patented integrity detection identifies AI-assisted responses — automatically.</p>
          </div>

          {/* SmartDevelop */}
          <div className="product-card" style={{ borderTopColor: '#a78bfa' }}>
            <div className="product-icon">🎓</div>
            <h3>SmartDevelop</h3>
            <p>AI career development engine guiding employees toward aspirational roles with a clear, measurable path.</p>
            <ul className="results-list">
              <li>→ Employees select their target role</li>
              <li>→ AI conducts a conversational readiness assessment</li>
              <li>→ Personalized development roadmap generated</li>
              <li>→ Clear path to the next stage of their career</li>
            </ul>
          </div>

          {/* SmartAssess */}
          <div className="product-card" style={{ borderTopColor: '#22d3ee' }}>
            <div className="product-icon">📋</div>
            <h3>SmartAssess</h3>
            <p>AI-powered assessments that measure real skills, competencies, and training effectiveness.</p>
            <ul className="results-list">
              <li>→ Knowledge gained during training programs</li>
              <li>→ Employee competencies across roles</li>
              <li>→ Workforce skill gaps</li>
            </ul>
            <p style={{ marginTop: '1rem', fontStyle: 'italic', color: 'var(--text-light)', fontSize: '0.95rem' }}>SmartAssess measures what employees actually know, not just what training they completed.</p>
          </div>

          {/* SmartAssist */}
          <div className="product-card" style={{ borderTopColor: '#34d399', position: 'relative', overflow: 'hidden' }}>
            <span className="product-badge">EARLY ACCESS</span>
            <div className="product-icon">🎧</div>
            <h3>SmartAssist</h3>
            <p>AI enterprise knowledge assistant providing instant conversational access to policies and documents. Employees can ask questions about company policies, procedures, and internal documentation.</p>
            <ul className="results-list">
              <li>→ Instant answers with source document references</li>
              <li>→ Dramatically reduces time spent searching portals</li>
              <li>→ 24/7 availability, any device</li>
              <li>→ Always up-to-date with latest policies</li>
            </ul>
          </div>

        </div>
      </div>
    </section>
  )
}
